import { motion } from 'framer-motion';
import { Link } from 'react-router-dom';
import { actorInfo } from '../../../mocks/portfolio';

const Hero = () => {
  const scrollToSection = (id: string) => {
    const element = document.getElementById(id);
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
    }
  };

  return (
    <section className="relative h-screen w-full overflow-hidden">
      {/* Background Image */}
      <div className="absolute inset-0 w-full h-full">
        <img
          src="https://www.dropbox.com/scl/fi/evclaohpwa7040t5o76v2/JordanDestin.jpg?rlkey=huqummpkd45n1jrrhcovlbavi&st=xz5fkskx&raw=1"
          alt="Hero background"
          className="w-full h-full object-cover object-top"
        />
        <div className="absolute inset-0 bg-gradient-to-b from-black/40 via-black/30 to-black/50"></div>
      </div>

      {/* Navigation */}
      <nav className="absolute top-0 left-0 right-0 z-20 px-8 py-6">
        <div className="max-w-7xl mx-auto flex items-center justify-between">
          <div className="text-white font-serif text-2xl font-semibold tracking-wider">
            JD
          </div>
          
          <div className="hidden md:flex items-center gap-8">
            <button
              onClick={() => scrollToSection('demo-reel')}
              className="text-white text-sm uppercase tracking-widest hover:text-burgundy transition-colors duration-300 cursor-pointer whitespace-nowrap"
            >
              Demo Reel
            </button>
            <button
              onClick={() => scrollToSection('press')}
              className="text-white text-sm uppercase tracking-widest hover:text-burgundy transition-colors duration-300 cursor-pointer whitespace-nowrap"
            >
              Press
            </button>
            <button
              onClick={() => scrollToSection('bio')}
              className="text-white text-sm uppercase tracking-widest hover:text-burgundy transition-colors duration-300 cursor-pointer whitespace-nowrap"
            >
              Bio
            </button>
            <button
              onClick={() => scrollToSection('gallery')}
              className="text-white text-sm uppercase tracking-widest hover:text-burgundy transition-colors duration-300 cursor-pointer whitespace-nowrap"
            >
              Gallery
            </button>
            <Link
              to="/filmography"
              className="text-white text-sm uppercase tracking-widest hover:text-burgundy transition-colors duration-300 cursor-pointer whitespace-nowrap"
            >
              Filmography
            </Link>
            <button
              onClick={() => scrollToSection('contact')}
              className="text-white text-sm uppercase tracking-widest hover:text-burgundy transition-colors duration-300 cursor-pointer whitespace-nowrap"
            >
              Contact
            </button>
          </div>

          <button
            onClick={() => scrollToSection('demo-reel')}
            className="px-6 py-2.5 border-2 border-white text-white rounded-full text-sm font-medium hover:bg-white hover:text-black transition-all duration-300 cursor-pointer whitespace-nowrap"
          >
            View Reel
          </button>
        </div>
      </nav>

      {/* Hero Content */}
      <div className="absolute inset-0 flex items-end z-10">
        <div className="w-full px-8 pb-24 max-w-7xl mx-auto">
          <motion.div
            initial={{ opacity: 0, y: 30 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.8, delay: 0.2 }}
          >
            <h1 className="font-serif text-7xl md:text-8xl lg:text-9xl font-bold text-white mb-4 drop-shadow-2xl">
              {actorInfo.name}
            </h1>
            <p className="text-white text-lg md:text-xl font-light tracking-wide">
              {actorInfo.tagline}
            </p>
          </motion.div>
        </div>
      </div>

      {/* Scroll Indicator */}
      <motion.div
        className="absolute bottom-8 left-1/2 transform -translate-x-1/2 z-10 cursor-pointer"
        animate={{ y: [0, 10, 0] }}
        transition={{ duration: 1.5, repeat: Infinity }}
        onClick={() => scrollToSection('demo-reel')}
      >
        <i className="ri-arrow-down-line text-white text-3xl"></i>
      </motion.div>
    </section>
  );
};

export default Hero;